module.exports = __webpack_public_path__ + "static/media/banner.4d197c0d.png";